import { render, staticRenderFns } from "./PopUpPhoneNumber.vue?vue&type=template&id=0b5a1dc3&scoped=true"
import script from "./PopUpPhoneNumber.vue?vue&type=script&lang=js"
export * from "./PopUpPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PopUpPhoneNumber.vue?vue&type=style&index=0&id=0b5a1dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a1dc3",
  null
  
)

export default component.exports